import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/base/SEOHead";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import WhyUsSection from "./components/WhyUsSection";
import TargetAudienceSection from "./components/TargetAudienceSection";
import ProcessSection from "./components/ProcessSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-brand-black">
      <SEOHead
        title="保險門神 Insurance Guardian | 專業財務顧問 | 先守護再成長"
        description="保險門神 Insurance Guardian - 專業財務顧問，從個人與家庭到企業與傳承，用專業把關讓保障有效、資產穩健、企業長久。提供保單健診、資產配置、退休規劃、企業風險管理等全方位服務。"
        keywords="保險門神,保險顧問,財務顧問,保單健診,資產配置,退休規劃,企業保險,風險管理,保險諮詢,財富傳承"
        canonicalPath="/"
        ogImage="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/0968609e615b455b3e5560365ff74ad7.png"
        ogType="website"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "FinancialService",
          "name": "保險門神 Insurance Guardian",
          "description": "專業財務顧問服務，提供保單健診、資產配置、退休規劃、企業風險管理等全方位服務。",
          "url": "__SITE_URL__/",
          "image": "https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/0968609e615b455b3e5560365ff74ad7.png",
          "sameAs": [
            "https://www.facebook.com/profile.php?id=61581854217759",
            "https://www.instagram.com/nefertari_0122"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "客戶服務",
            "availableLanguage": "Chinese"
          },
          "areaServed": {
            "@type": "Country",
            "name": "Taiwan"
          }
        }}
      />
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyUsSection />
        <TargetAudienceSection />
        <ProcessSection />
        <TestimonialsSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}